"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
function constantFactory(name, constantList) {
    var _a;
    var list = constantList.map(function (item) {
        return __assign(__assign({}, item), { name: item.label, label: item.label });
    });
    var map = constantList.reduce(function (result, item) {
        result[item.value] = item.label || item.name;
        return result;
    }, {});
    var type = constantList.reduce(function (result, item) {
        result[item.key] = item.value;
        return result;
    }, {});
    var itemMap = constantList.reduce(function (result, item) {
        result[item.value] = item;
        return result;
    }, {});
    return _a = {},
        _a[name] = type,
        _a[name + "_LIST"] = list,
        _a[name + "_MAP"] = map,
        _a[name + "_ITEM_MAP"] = itemMap,
        _a;
}
exports.default = constantFactory;
//# sourceMappingURL=index.js.map